import React from 'react';
import {input} from "../translate";
import Cookies from "js-cookie";

function ProfileComponent({form,handleChange,type,handleWheel,form_name}) {
    return (
        <div className="d-flex align-items-center">
            <input
                style={!form[form_name+'Check'] && Cookies.get('viewer') && Cookies.get('original') || !Cookies.get('viewer') && !Cookies.get('original')?{color:'#acacac'}:{}} disabled={!form[form_name+'Check'] && Cookies.get('viewer') && Cookies.get('original')|| !Cookies.get('viewer') && !Cookies.get('original')}

                onWheel={handleWheel} type={type} value={form[form_name]}
                onChange={(ev) => handleChange(form_name, ev.target.value)}/>
            {Cookies.get('viewer') && Cookies.get('original')?<input checked={form[form_name+'Check']} onClick={(ev) => handleChange(form_name+'Check',ev.target.checked)} type="checkbox"/>:null}

        </div>

    );
}

export default ProfileComponent;